import { defineMessages } from "react-intl";

export default defineMessages({
  transferPlayer: {
    id: "TransferPlayerDialog.transferPlayer",
    defaultMessage: "Transfer player",
  },
});
